import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Diagnosticprojets.css";
import Breadcrumb from './Breadcrumb';
import CallToAction from './CallToAction';


const DiagnosticProjets = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [diagnosticData, setDiagnosticData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    nom: "",
    email: "",
    telephone: "",
    entreprise: "",
    message: ""
  });

  // État pour les données du hero (titre et description de la rubrique)
  const [heroData, setHeroData] = useState({
    title: "Vos projets accusent des retards ou dépassent les budgets ?",
    subtitle: "Dans de nombreuses organisations, les projets échouent non pas par manque de volonté, mais par manque de méthode, de coordination et de compétences structurées.",
    text: "Nous vous aidons à identifier rapidement les causes de ces dysfonctionnements et à mettre en place des solutions concrètes."
  });

  // Récupérer les données depuis l'API
  useEffect(() => {
    fetchDiagnosticData();
  }, []);

  const fetchDiagnosticData = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Diagnostic-de-projets`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success && data.data) {
        const rubriqueData = data.data;

        // Fonction pour nettoyer le HTML
        const cleanText = (html) => {
          if (!html) return '';
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          return tempDiv.textContent || tempDiv.innerText || '';
        };

        // 1. Mettre à jour les données du hero (titre, sous-titre, description de la rubrique)
        // setHeroData({
        //   title: cleanText(rubriqueData.titre) || "Entreprises",
        //   subtitle: cleanText(rubriqueData.soustitre) || "Des solutions sur mesure pour optimiser la performance de vos projets.",
        //   text: cleanText(rubriqueData.descriptif) || "Découvrez nos trois offres complémentaires conçues pour répondre aux défis spécifiques de votre organisation en matière de gestion de projet."
        // });

        // 2. Récupérer les articles (services) depuis l'API
        if (rubriqueData.articles && rubriqueData.articles.length > 0) {
          const formattedblocks = rubriqueData.articles.map((article, index) => {
            // Déterminer le chemin et la couleur en fonction du titre
            let color = "";

            if (article.titre === "Le Problème : Retards, budgets, inefficacité") {
              color = "blue";
            } else if (article.titre === "Notre Solution : Un Diagnostic de performance") {
              color = "green";
            } else if (article.titre === "Notre Méthodologie : analyse, interviews, recommandations, résultats attendus") {
              color = "teal";
            } else if (article.titre === "Mise en œuvre des recommandations") {
              color = "orange";
            }

            return {
              id: article.id_article,
              title: cleanText(article.titre),
              description: (article.soustitre) || (article.descriptif) || (article.texte),
              // path: path,
              color: color
            };
          });
          setDiagnosticData(formattedblocks);
        }
        else {
          // Services par défaut si pas d'articles
          setDiagnosticData([
            {
              id: 1,
              title: "Le Problème : Retards, budgets, inefficacité",
              description: "De nombreuses organisations rencontrent des difficultés récurrentes dans la conduite de leurs projets : retards fréquents, dépassements de budget, manque de coordination entre les équipes et résultats en deçà des attentes. Ces dysfonctionnements ne sont généralement pas liés à un manque d’engagement, mais à l’absence de méthodes structurées, de pilotage efficace et de compétences adaptées.",
              color: "blue"
            },
            {
              id: 2,
              title: "Notre Solution : Un Diagnostic de performance",
              description: "Pour répondre à ces enjeux, nous proposons un diagnostic de performance des projets, permettant d’identifier rapidement les causes réelles des inefficacités. Cette approche ciblée met en lumière les points de blocage et fournit une vision claire des améliorations nécessaires pour renforcer la maîtrise et la réussite des projets.",
              color: "green"
            },
            {
              id: 3,
              title: "Notre Méthodologie : analyse, interviews, recommandations, résultats attendus",
              description: "Notre démarche repose sur une analyse structurée des projets récents, complétée par des entretiens avec les parties prenantes clés. À partir de ces éléments, nous formulons des recommandations concrètes, priorisées et adaptées à votre contexte. L’objectif est d’apporter des solutions directement applicables, permettant d’améliorer la gestion des délais, des coûts et des risques, tout en renforçant la performance globale de vos projets.",
              color: "blue"
            },
            {
              id: 4,
              title: "Mise en œuvre des recommandations",
              description: "Au-delà du diagnostic, nous vous accompagnons dans la mise en œuvre des actions recommandées afin de garantir des résultats concrets.",
              color: "green"
            }
          ]);
        }
      } else {
        throw new Error('Données de rubrique non disponibles');
      }

    } catch (err) {
      console.error('Erreur lors de la récupération des données:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cta = {
    title: "Prêt à optimiser la performance de vos projets ?",
    subtitle: "Obtenez un diagnostic complet et personnalisé de votre gestion de projet",
    buttonText: "Demander un diagnostic"
  }
  const modal = {
    title: "Demande de diagnostic",
    subtitle: "Remplissez ce formulaire et nous vous contacterons sous 48h",
    submitButton: "Envoyer la demande"
  }


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Formulaire soumis:", formData);
    alert("Merci ! Nous vous contacterons rapidement pour organiser votre diagnostic.");
    setIsModalOpen(false);
    setFormData({
      nom: "",
      email: "",
      telephone: "",
      entreprise: "",
      message: ""
    });
  };

  // Fonction pour gérer la redirection vers la page contact
  const handleContactClick = () => {
    navigate("/contactez-nous#form"); // Redirige vers la page /contact
  };

  if (isLoading) {
    return (
      <div className="diagnostic-loading-container">
        <div className="diagnostic-spinner"></div>
        <p>Chargement...</p>
      </div>
    );
  }

  if (error) {
    return (
      <section className="section what-you-learn" id="programme" >
        <div className="contenir">
          <h2 className="section-title">1-Diagnostic de projets</h2>
          <p className="section-subtitle" style={{ color: '#ff6b6b' }}>
            Erreur de chargement : {error}
          </p>
        </div>
      </section>
    );
  }

  return (
    <>
      {/* <Breadcrumb /> */}
      <div className="diagnostic-page">
        {/* Hero Section */}
        {/* <div className="diagnostic-page-hero">
          <div className="diagnostic-page-hero-overlay"></div>
          <div className="diagnostic-page-hero-content">
            <h1 className="diagnostic-page-hero-title">{heroData.title}</h1>
            <p className="diagnostic-page-hero-subtitle">{heroData.subtitle}</p>
            <p className="diagnostic-page-hero-text">{heroData.text}</p>
          </div>*/}
        <h1 className="section-title"> 1-Diagnostic de projets</h1>
        <p className="section-subtitle">
          Vos projets accusent des retards ou dépassent les budgets ?
          <br />
          Dans de nombreuses organisations, les projets échouent non pas par manque de volonté, mais par manque de méthode,
          de coordination et de compétences structurées. Nous vous aidons à identifier rapidement les causes de ces dysfonctionnements
          et à mettre en place des solutions concrètes.
        </p>

        {/* BLOCS DYNAMIQUES - Uniquement titre + description */}
        {diagnosticData && diagnosticData.length > 0 && (
          <div className="three-blocks-container">
            {diagnosticData.map((block, index) => (
              <div
                key={block.id}
                className={`diagnostic-block diagnostic-block-${block.color || 'blue'}`}
              >
                <div className="diagnostic-block-circle diagnostic-block-circle-1"></div>
                <div className="diagnostic-block-circle diagnostic-block-circle-2"></div>

                <div className="diagnostic-block-header">
                  <div className="diagnostic-block-number-circle">{String.fromCharCode(97 + index)}</div>
                  <h3 className="diagnostic-block-title">{block.title}</h3>
                </div>

                <div
                  className="diagnostic-page-section-text"
                  dangerouslySetInnerHTML={{ __html: block.description }}
                />
                {/* <p className="diagnostic-block-text">{block.description}</p> */}
              </div>
            ))}
          </div>
        )}

      </div>


      {/* Call to Action */}
      {/* <div className="diagnostic-page-cta">
          <div className="diagnostic-page-cta-content">
            <h2>{cta.title}</h2> */}
      {/* <p>{diagnosticData.cta.subtitle}</p> */}
      {/* <button className="diagnostic-page-cta-button">
              {cta.buttonText}
            </button>
          </div>
        </div> */}

      <CallToAction
        title="Prêt à optimiser la performance de vos projets ?"
        // button1Text="Ecrire WhatsApp"
        button2Text="Demander un diagnostic"
        // onButton1Click={() => window.open('https://wa.me/2290158585050', '_blank')}
        onButton2Click={handleContactClick}
      // button1Icon={<FaWhatsapp />}
      />

      {/* Modal Formulaire */}
      {isModalOpen && (
        <div className="diagnostic-page-modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="diagnostic-page-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="diagnostic-page-modal-close" onClick={() => setIsModalOpen(false)}>✕</button>
            <h2>{modal.title}</h2>
            <p>{modal.subtitle}</p>

            <form onSubmit={handleSubmit} className="diagnostic-page-form">
              <div className="diagnostic-page-form-group">
                <label>Nom complet *</label>
                <input
                  type="text"
                  name="nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                  required
                  placeholder="Votre nom"
                />
              </div>

              <div className="diagnostic-page-form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="votre@email.com"
                />
              </div>

              <div className="diagnostic-page-form-group">
                <label>Téléphone</label>
                <input
                  type="tel"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleInputChange}
                  placeholder="Votre numéro"
                />
              </div>

              <div className="diagnostic-page-form-group">
                <label>Entreprise</label>
                <input
                  type="text"
                  name="entreprise"
                  value={formData.entreprise}
                  onChange={handleInputChange}
                  placeholder="Nom de votre entreprise"
                />
              </div>

              <div className="diagnostic-page-form-group">
                <label>Message (optionnel)</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="4"
                  placeholder="Décrivez brièvement vos besoins..."
                ></textarea>
              </div>

              <button type="submit" className="diagnostic-page-submit-button">
                {modal.submitButton}
              </button>
            </form>
          </div>
        </div>
      )}
      {/* </div> */}
    </>
  );
};

export default DiagnosticProjets;